<template>
  <Tooltip class="item" effect="dark" placement="bottom">
    <div slot="content" class="checkbox_instruction tooltipcontent">
      <div class="tooltipcontent_header">REPORT HEADERS</div>
      <ul class="flexgroup">
        <li v-for="(header,index) in reportHeaders" v-bind:key='index'>
          {{ header }}
        </li>
      </ul>
    </div>
    <button class="infobtn">
      <svgicon name="info-black"  class="icon"
        width="14" height="14" :original="true" />
    </button>
  </Tooltip>
</template>
<script>
export default {
  props: ['reportHeaders'],
};
</script>
